module.exports = __webpack_public_path__ + "./images/p23.JPG?6b4036187df46de038d49ef1650f5661";


//////////////////
// WEBPACK FOOTER
// ./src/products/p23.JPG
// module id = 59
// module chunks = 0